/**
 * 招待管理ページ コンテナ
 */

import { AuthContext } from "hooks/authProvider/authProvider";
import {
  type CreateInvitationInput,
  useCancelInvitation,
  useCreateInvitation,
  useInvitations,
} from "hooks/useInvitationsApi";
import { useTenantDetailApi } from "hooks/useTenantApi";
import type React from "react";
import { useCallback, useContext } from "react";
import { InvitationsPage } from "routes/settings/InvitationsPage/InvitationsPage";
import { getCurrentTenant } from "utils/authority-utils";

const InvitationsPageContainer: React.FC = () => {
  const { currentUser } = useContext(AuthContext);
  const tenant = getCurrentTenant(currentUser ?? null);
  const tenantId = tenant?.id ?? "";
  const { data: tenantDetail } = useTenantDetailApi(tenantId);

  const { invitations, loading, error, refetch } = useInvitations();
  const { createInvitation, loading: isCreating } = useCreateInvitation();
  const { cancelInvitation, loading: isCancelling } = useCancelInvitation();

  const handleCreateInvitation = useCallback(
    async (input: CreateInvitationInput) => {
      const result = await createInvitation(input);
      await refetch();
      return result;
    },
    [createInvitation, refetch],
  );

  const handleCancelInvitation = useCallback(
    async (invitationId: string) => {
      await cancelInvitation(invitationId);
      await refetch();
    },
    [cancelInvitation, refetch],
  );

  return (
    <InvitationsPage
      invitations={invitations}
      loading={loading}
      error={error ? { message: error.message } : null}
      onCreateInvitation={handleCreateInvitation}
      onCancelInvitation={handleCancelInvitation}
      isCreating={isCreating}
      isCancelling={isCancelling}
      hasCrmLicense={tenantDetail?.licenses.includes("CRM") ?? false}
    />
  );
};

export default InvitationsPageContainer;
